import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const FaqSection = ({ heading = "Frequently asked", subheading = "", items = [], testIdPrefix = "faq" }) => {
    const [open, setOpen] = useState(0);

    return (
        <section className="section" data-testid={`${testIdPrefix}-section`}>
            <div className="container" style={{ maxWidth: 840 }}>
                <div className="section-head left">
                    <span className="eyebrow">FAQ</span>
                    <h2 className="h2" style={{ marginTop: 18 }}>{heading}</h2>
                    {subheading && <p>{subheading}</p>}
                </div>
                <div className="faq-list">
                    {items.map((it, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={it.q}
                                className={`faq-item ${isOpen ? "open" : ""}`}
                                data-testid={`${testIdPrefix}-item-${i}`}
                            >
                                <button
                                    type="button"
                                    className="faq-q"
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                    data-testid={`${testIdPrefix}-q-${i}`}
                                >
                                    <h3 className="faq-q-text">{it.q}</h3>
                                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                                </button>
                                {/*
                                  Always render the answer into the DOM so it
                                  is visible to crawlers and AI assistants.
                                  Visual collapse is handled in CSS via
                                  height/opacity on `.faq-a` — same content
                                  for users and crawlers, just visually
                                  collapsed by default.
                                */}
                                <div
                                    className="faq-a"
                                    data-testid={`${testIdPrefix}-a-${i}`}
                                    aria-hidden={!isOpen}
                                >
                                    {it.a}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
